import createSweepRuleForSenderRequest from 'owa-service/lib/factory/createSweepRuleForSenderRequest';
import createSweepRuleForSenderOperation from 'owa-service/lib/operation/createSweepRuleForSenderOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
/**
 * Helper function to create the empty rule names array which has the same length of the emailAddresses array.
 * This is a workaround for server validation and will be removed after fixing
 * VSO 8796: Improve validation for utah CreateSweepRuleForSenderAction
 */
function createRuleNames(emailAddresses) {
    return emailAddresses.map(function (email) {
        return '';
    });
}
/**
 * Apply bulk item action service
 * @param emailAddresses the email addresses to be blocked
 * @return the ApplyBulkItemActionResponse
 */
export default function blockSenderService(emailAddresses) {
    var requestBody = createSweepRuleForSenderRequest({
        EmailAddresses: emailAddresses,
        ActionType: 2 /* Block */,
        RuleName: null /* deprecated required param*/,
        RuleNames: createRuleNames(emailAddresses),
    });
    return createSweepRuleForSenderOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=blockSenderService.js.map